<style lang="less" scoped>
  .warranty-apply {
    display: flex;
    flex-direction: column;
    height: 100%;
    ._apply-form {
      flex: 1;
      padding: 18rpx 30rpx 30rpx;
      overflow: hidden auto;
    }
    ._apply-declartion {
      display: flex;
      align-items: center;
      .__declartion {
        flex: 1;
        display: flex;
        align-items: center;
        margin-left: 20rpx;
        font-size: 0.9rem;
        font-weight: 400;
        color: #1989fa;
      }
    }
    ._apply-submit {
      flex: 0 0 auto;
      background: #f7f7f7;
      ._btn {
        display: block;
        width: 100%;
        height: 100rpx;
        padding: 0;
        color: #fff;
        background: @DefaultColor;
        border: 0;
        outline: 0;
        transition: background-color 0.2s ease;
        &[disabled] {
          background: #e2e2e2;
        }
      }
    }
    ._field-title {
      padding: 36rpx 0;
      font-weight: 600;
      color: #343434;
    }
    ._apply-remark {
      width: 100%;
      min-width: 100%;
      max-width: 100%;
      height: 300rpx;
      min-height: 300rpx;
      max-height: 300rpx;
      padding: 20rpx;
      background: #fff;
      border-radius: 20rpx;
      outline: 0;
      border: 0;
      box-sizing: border-box;
      resize: none;
    }
    ._apply-product {
      padding: 30rpx 18rpx 40rpx 30rpx;
      border-radius: 20rpx;
      background: #fff;
      ._product-info {
        display: flex;
        overflow: hidden;
      }
      .dtl-img {
        flex: 0 0 auto;
        width: 160rpx;
        height: 160rpx;
        margin-right: 18rpx;
        border-radius: 10rpx;
      }
      .dtl-info {
        flex: 1;
        position: relative;
        overflow: hidden;
      }
      .dtl-name {
        max-height: 3em;
        margin-bottom: 18rpx;
        font-size: 0.9rem;
        color: #333;
        line-height: 1.5;
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .dtl-spec {
        font-size: 0.875rem;
        color: #999;
        line-height: 1.5;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      ._product-picker {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 30rpx;
        color: #9a9a9a;
      }
      ._picker-icon {
        display: flex;
        align-items: center;
      }
    }
    ._apply-upload {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .van-uploader__preview-item {
        position: relative;
        width: 152rpx;
        height: 152rpx;
        margin: 0 20rpx 20rpx 0;
        border-radius: 20rpx;
      }
      .van-uploader__preview-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 20rpx;
      }
      .van-uploader__preview-remove {
        position: absolute;
        top: 0px;
        right: 0px;
        width: 40rpx;
        height: 40rpx;
        background: rgba(0, 0, 0, 0.7);
        border-radius: 40rpx;
        font-size: 12px;
        font-weight: 900;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .send-modal {
      width: 70%;
      border-radius: 20rpx;
      font-size: 0.9rem;
    }
    .send-modal-title {
      padding: 1em 0;
      margin-bottom: 1em;
      color: #666;
      text-align: center;
      line-height: 1;
      border-bottom: 1px solid #e7e7e7;
    }
    .send-modal-main {
      display: flex;
      align-items: flex-start;
      padding: 0 20rpx;
      margin-top: 10rpx;
    }
    .send-modal-left {
      flex: 1;
      margin-right: 10rpx;
    }
    .send-modal-input {
      width: 100%;
      height: 70rpx;
      border: 0;
      outline: 0;
      color: #333;
      padding: 16rpx 30rpx;
      background: #f0f0f0;
      box-sizing: border-box;
      border-radius: 10rpx;
    }
    .send-modal-error {
      height: 1em;
      padding: 0 0 0 30rpx;
      margin-top: 10rpx;
      font-size: 12px;
      color: #ff5859;
      line-height: 1;
    }
    .send-modal-right {
      flex: 0 0 auto;
      border: 0;
      outline: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 70rpx;
      box-sizing: border-box;
      padding: 0 10rpx;
      background: #ff5859;
      color: #fff;
      border-radius: 10rpx;
      transition: background-color 0.2s ease;
      &[disabled] {
        background: #999;
      }
    }
    .send-modal-submit {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20rpx 30rpx 20rpx;
      margin-top: 1em;
      border-top: 1px solid #e7e7e7;
    }
    .send-modal-button {
      flex: 0 0 auto;
      height: 70rpx;
      padding: 0 60rpx;
      font-weight: 600;
      color: #fff;
      background: #ff5859;
      border-radius: 10rpx;
      border: 0;
      outline: 0;
    }
    .send-modal-cancel {
      font-weight: 500;
      color: #666;
      background: #fff;
      border: 1px solid #e7e7e7;
    }
    .send-modal-confirm {
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background-color 0.2s ease;
      &[disabled] {
        background: #999;
      }
    }
    .declartion-preview {
      display: flex;
      flex-direction: column;
      width: 96vw;
      height: 96vh;
      overflow: hidden;
      .__body {
        flex: 1;
        overflow: hidden auto;
      }
      .__body-img {
        display: block;
        width: 100%;
        background: #fff;
      }
      .__footer {
        padding-top: 20rpx;
        font-size: 30rpx;
        color: #f1f1f1;
        text-align: center;
        line-height: 1;
      }
    }
  }
</style>
<style lang="less">
  .warranty-apply {
    ._apply-upload {
      .van-uploader {
        flex: 0 0 auto;
        width: 152rpx;
        height: 152rpx;
        margin: 0 0 20rpx 0;
      }
      .van-uploader__input-wrapper {
        position: relative;
        width: 152rpx;
        height: 152rpx;
        border-radius: 20rpx;
        background: #fff;
      }
      .van-uploader__icon {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 64rpx;
        height: 52rpx;
        transform: translate(-50%, -50%);
      }
      .van-uploader__loading {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        color: #ff585a;
        background: rgba(0, 0, 0, 0.2);
        border-radius: 20rpx;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10;
      }
    }
  }
</style>

<template>
  <div class="warranty-apply">
    <van-empty v-if="errorShow"
                :image="`${sysConstConfig.webPath}/platform-assets/common/icon_empty.png`"
               description="订单未查到" />

    <template v-else>
      <div class="_apply-form">
        <div class="_apply-product">
          <div class="_product-info">
            <!-- 成品，优先取规格图其次选取主图最后默认图 -->
            <template v-if="orderDtl.storeOrderDtls[0].product.productType === 1">
              <img v-if="orderDtl.storeOrderDtls[0].product.productSkuList[0].imgPath"
                   class="dtl-img"
                   :src="orderDtl.storeOrderDtls[0].product.productSkuList[0].imgPath">
              <img v-else-if="orderDtl.storeOrderDtls[0].product.mainImg"
                   class="dtl-img"
                   :src="orderDtl.storeOrderDtls[0].product.mainImg">
              <img v-else
                   class="dtl-img"
                   src="~@/assets/default_product.png">
            </template>
            <!-- 定制，优先取主图其次取默认图 -->
            <template v-else>
              <img v-if="orderDtl.storeOrderDtls[0].product.mainImg"
                   class="dtl-img"
                   :src="orderDtl.storeOrderDtls[0].product.mainImg">
              <img v-else
                   class="dtl-img"
                   src="~@/assets/default_product.png">
            </template>

            <div class="dtl-info">
              <div class="dtl-name">{{ orderDtl.storeOrderDtls[0].product.name }}</div>
              <div v-if="sysConstConfig.showSpecName === 'yes'"
                   class="dtl-spec"
                   v-html="skuFormat(orderDtl.storeOrderDtls[0].product)"></div>
            </div>
          </div>

          <div v-if="orderDtl.storeOrderDtls[0].product.childProductList"
               @click="selectedChildFn"
               class="_product-picker">
            <span>质保部位</span>
            <div class="_picker-icon">
              <span>{{ selectedChild.name }}</span>
              <van-icon name="arrow" />
            </div>
          </div>
        </div>

        <div class="_field-title">
          <div class="_apply-declartion">
            <span>问题描述</span>
            <div v-if="declartionList.length"
                 class="__declartion"
                 @click="previewDeclartion(true)">
              <van-icon name="info" />
              <span v-if="applyType === 1"
                    style="margin-left:5px;">查看质保说明</span>
              <span v-else
                    style="margin-left:5px;">查看膜险说明</span>
            </div>
          </div>
        </div>
        <textarea class="_apply-remark"
                  v-model="questionContent"
                  placeholder="请输入输入您的问题"></textarea>
        <div class="_field-title">上传凭证</div>
        <div class="_apply-upload">
          <div class="van-uploader__preview-item"
               v-for="(pre, index) in imgPreviewList"
               :key="index">
            <img :src="pre"
                 @click="ImagePreviewFn(index)"
                 class="van-uploader__preview-img">
            <span class="van-uploader__preview-remove"
                  @click="removeFromList(index)">
              <van-icon size="1em"
                        color="#fff"
                        name="cross" />
            </span>
          </div>
          <van-uploader v-model="uploader"
                        accept="image/*"
                        :preview-image="false"
                        :max-size="imgSize * 1024 * 1024"
                        result-type="file"
                        :before-read="handleFileBeforeRead"
                        :after-read="handleFileAfterRead"
                        :multiple="false">
            <img class="van-uploader__icon"
                 src="~@/assets/icon_photo_upload.png"
                 alt="">
            <van-loading v-show="uploading"
                         class="van-uploader__loading"
                         :size="28" />
          </van-uploader>
        </div>
      </div>

      <div class="safe-area-bottom _apply-submit">
        <button class="_btn"
                @click="validateFn"
                :disabled="submitAble">提交申请</button>
      </div>
    </template>

    <van-action-sheet v-model="sheetShow"
                      :actions="orderChildProducts"
                      cancel-text="取消"
                      title="请选择"
                      :closeable="false"
                      :round="false"
                      @select="sheetSelectFn"
                      close-on-click-action>
    </van-action-sheet>

    <van-loading v-show="loading"
                 class="my-loading-style"
                 size="40"></van-loading>

    <!-- 获取验证码 -->
    <van-popup v-model="verifyModalShow"
               close-on-popstate
               class="send-modal"
               :close-on-click-overlay="false">
      <div class="send-modal-title">获取验证码</div>
      <div class="send-modal-main">
        <div class="send-modal-left">
          <input class="send-modal-input"
                 type="text"
                 v-model="verifyCode"
                 @blur="verifyCodeFormatFn"
                 placeholder="验证码">
        </div>
        <button :disabled="isCountDowning"
                @click="sendVerifyCodeFn"
                class="send-modal-right">
          <van-loading v-show="isGetVerifyCodeLoading"
                       color="#fff"
                       style="margin-right:5px;"
                       :size="12" />
          <span>{{ verifyButtonText }}</span>
        </button>
      </div>
      <div class="send-modal-error">{{ verifyCodeError }}</div>
      <div class="send-modal-submit">
        <button @click="closeVerifyModalFn"
                class="send-modal-button send-modal-cancel">取消</button>
        <button :disabled="!verifyCode"
                @click="submitApplitionFn"
                class="send-modal-button send-modal-confirm">
          <van-loading v-show="isVerifying"
                       color="#fff"
                       style="margin-right:5px;"
                       :size="12" />
          <span>确定</span>
        </button>
      </div>
    </van-popup>
    <!-- 质保/膜险说明 -->
    <van-popup v-model="declartionShow"
               :style="{background:'rgba(0,0,0,0)'}">
      <div class="van-popup--safe-area-inset-bottom declartion-preview">
        <div class="__body">
          <img v-for="(item, index) in declartionList"
               :key="index"
               :src="item"
               class="__body-img">
        </div>
        <div class="__footer"
             @click="previewDeclartion(false)">
          <van-icon name="clear" />
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
  import { uploadImages, getVerifyCode, queryOrderWarrantyDtl, submitApplition, getDeclartion } from '@/config/api.js'
  import photoCompress from '@/util/photo-compress.js'

  export default {
    name: 'WarrantyApply',
    computed: {
      submitAble () {
        if (this.orderDtl.orderType === 2) {
          return !this.selectedChild.id || !this.questionContent || !this.imgPreviewList.length
        } else {
          return !this.questionContent || !this.imgPreviewList.length
        }
      }
    },
    data () {
      return {
        uploading: false,
        loading: false,
        errorShow: true,
        tenantId: '',
        orderDtlId: '',
        sheetShow: false,
        orderDtl: {
          orderType: 1,
          storeOrderDtls: []
        },
        imgSize: 10,
        orderChildProducts: [],
        selectedChild: {
          id: '',
          skuId: '',
          index: '',
          name: '请选择质保部位'
        },
        uploader: [],
        imgPreviewList: [],
        questionContent: '',
        verifyModalShow: false,
        countDownTimer: null,
        verifyCode: '',
        verifyCodeError: '',
        verifyButtonText: '获取验证码',
        isCountDowning: false,
        isGetVerifyCodeLoading: false,
        isVerifying: false,
        applyType: 1,
        declartionShow: false,
        declartionList: []
      }
    },
    methods: {
      skuFormat (data) {
        if (!data) { return '-' }
        /*
          成品 规格
          定制 子商品名：规格
              子商品名：规格
        **/
        let _result = []
        if (data.productType === 1) {
          if (data.productSkuList[0].hasProperty === 1) {
            data.productSkuList[0].propertyBindList.forEach(element => {
              const _spec = element.productPropertyDtlBindList[0].productPropertyDtl.name
              _result.push(_spec)
            })
            return _result.join('、')
          } else {
            return '无规格'
          }
        } else {
          if (data.childProductList) {
            data.childProductList.forEach(element => {
              if (element.productSkuList[0].hasProperty === 1) {
                const _spec = []
                element.productSkuList[0].propertyBindList.forEach(item => {
                  _spec.push(item.productPropertyDtlBindList[0].productPropertyDtl.name)
                })
                _result.push(`${element.name}：${_spec.join('、')}`)
              } else {
                _result.push(`${element.name}：无规格`)
              }
            })
          } else {
            return '无规格'
          }
        }
        return _result.join('<br>')
      },
      removeFromList (index) {
        this.imgPreviewList.splice(index, 1)
      },
      handleFileBeforeRead (file, detail) {
        if (/^image\/(jpg|jpeg|png)$/i.test(file.type) === false) {
          this.$toast('请选择JPG、PNG格式的图片')
          return false
        }
        if (file.size > this.imgSize * 1024 * 1024) {
          this.$toast(`图片大小不能超过 ${this.imgSize} M`)
          return false
        }
        this.uploading = true
        return true
      },
      handleFileAfterRead (file, detail) {
        const imgType = file.file.type.replace('image/', '')

        photoCompress(file.file, { minSize: 100, format: imgType }).then(res => {
          if (res.success) {
            const formData = new FormData()
            formData.append('file', res.result.file)
            uploadImages(formData).then(response => {
              this.uploading = false
              if (response.success) {
                this.imgPreviewList.splice(0, 0, response.result)
              }
            })
          } else {
            this.$toast(res.message)
          }
        })
      },
      closeVerifyModalFn () {
        this.verifyModalShow = false
        this.countDownTimer = null
        this.verifyCode = ''
        this.verifyCodeError = ''
        this.verifyButtonText = '获取验证码'
        this.isCountDowning = false
        this.isGetVerifyCodeLoading = false
        this.isVerifying = false
      },
      verifyCodeFormatFn (e) {
        const _val = e.target.value.replace(/\s/g, '')
        if (_val === '') {
          this.verifyCodeError = '验证码为空'
          return false
        }
        this.verifyCodeError = ''
      },
      sendVerifyCodeFn () {
        this.isGetVerifyCodeLoading = true
        getVerifyCode(this.orderDtl.id).then(res => {
          this.isGetVerifyCodeLoading = false
          if (res.success) {
            this.isCountDowning = true
            this.countDownFn()
          }
        })
      },
      countDownFn () {
        const that = this
        let count = 60
        that.verifyButtonText = `重新获取(${count})`
        that.countDownTimer = window.setInterval(function () {
          count--
          if (count <= 0) {
            that.isCountDowning = false
            that.verifyButtonText = '获取验证码'
            clearInterval(that.countDownTimer)
            that.countDownTimer = null
          } else {
            that.verifyButtonText = `重新获取(${count})`
          }
        }, 1000)
      },
      validateFn () {
        const _code = localStorage.getItem('apply_auth_code') || ''
        if (_code) {
          // 提交
          this.verifyCode = _code
          this.submitApplitionFn()
        } else {
          this.verifyModalShow = true
          this.verifyCode = ''
        }
      },
      submitApplitionFn () {
        const params = {
          type: this.applyType,
          id: '',
          customerId: this.orderDtl.storeCustomer.id,
          customerRemark: this.questionContent,
          delFlag: this.orderDtl.delFlag,
          orderDtlId: this.orderDtl.storeOrderDtls[0].id,
          orderId: this.orderDtl.storeOrderDtls[0].orderId,
          parentSkuId: this.orderDtl.storeOrderDtls[0].skuId,

          productId: this.orderDtl.orderType === 1 ? this.orderDtl.storeOrderDtls[0].product.id : this.selectedChild.id,
          skuId: this.orderDtl.orderType === 1 ? this.orderDtl.storeOrderDtls[0].skuId : this.selectedChild.skuId,
          storeOrderQualityAssuranceApplyImgList: [],
          tenantRemark: ''
        }
        this.imgPreviewList.forEach(item => {
          params.storeOrderQualityAssuranceApplyImgList.push({ imgPath: item })
        })
        this.isVerifying = true
        submitApplition({
          code: this.verifyCode,
          data: params
        }).then(res => {
          this.isVerifying = false
          if (res.success) {
            localStorage.setItem('apply_auth_code', this.verifyCode)
            this.closeVerifyModalFn()
            const that = this
            this.$notify({
              type: 'success',
              message: '提交成功',
              duration: 1000,
              onClose () {
                that.$router.go(-1)
              }
            })
          } else {
            if (res.code === 10010) {
              localStorage.setItem('apply_auth_code', '')
              this.verifyModalShow = true
            }
          }
        })
      },
      selectedChildFn () {
        this.sheetShow = true
      },
      sheetSelectFn (data, num) {
        this.orderChildProducts.forEach((item, index) => {
          this.orderChildProducts[index].color = '#666'
        })
        this.orderChildProducts[num].color = '#ff585a'
        this.selectedChild.id = this.orderChildProducts[num].id
        this.selectedChild.skuId = this.orderChildProducts[num].skuId
        this.selectedChild.index = num
        this.selectedChild.name = this.orderChildProducts[num].name
      },
      ImagePreviewFn (index) {
        const _list = [].concat(this.imgPreviewList)
        this.$imagePreview({
          images: _list,
          startPosition: index,
          closeable: true
        })
      },
      previewDeclartion (bol) {
        this.declartionShow = bol
      }
    },
    mounted () {
      this.applyType = this.$route.meta.type === 'after-sales' ? 1 : 2 // 1 质保 2 膜险
      this.errorShow = true
      this.tenantId = this.$route.query.usr || ''
      this.orderDtlId = this.$route.query.dtl || ''
      this.declartionList = []
      if (this.tenantId && this.orderDtlId) {
        this.loading = true
        queryOrderWarrantyDtl({
          orderDtlId: this.orderDtlId,
          tenantId: this.tenantId
        }).then(res => {
          this.loading = false
          if (res.success) {
            this.errorShow = false
            this.orderDtl = res.result
            if (res.result.storeOrderDtls && res.result.storeOrderDtls[0].product.childProductList) {
              const _len = res.result.storeOrderDtls[0].product.childProductList.length
              res.result.storeOrderDtls[0].product.childProductList.forEach((item, index) => {
                this.orderChildProducts.push({
                  id: item.id,
                  skuId: item.productSkuList[0].id,
                  name: item.name,
                  color: '#666',
                  className: (index === _len - 1) ? 'van-hairline--bottom' : ''
                })
              })
            }
            if (res.result.storeOrderDtls && res.result.storeOrderDtls[0]) {
              getDeclartion(this.applyType, this.tenantId, res.result.storeOrderDtls[0].product.id).then(res => {
                if (res.success && res.result) {
                  this.declartionList = res.result.imgPath.split(',')
                }
              })
            }
          } else {
            this.errorShow = true
          }
        })
      }
    }
  }
</script>